import { useEffect } from 'react';

const useDocumentTitle = (title) => {
  useEffect(() => {
    const baseTitle = "Invic's Portfolio";
    document.title = title ? `${baseTitle} | ${title}` : baseTitle;
  }, [title]);
};

export default useDocumentTitle; 